import { GraphQLError } from "graphql"



export class TestbedRxdbError {

    static extractMsg(error) {
        if ( !error ) {
            return null
        }
        let rtnMsg = 'Error'
        if ( error.code == 'VD2' && error.parameters?.errors ) {
            //console.error(error)
            // If using ajs validation plugin, we can get the specific fields...
            const msgs = error.parameters.errors.map( paramError => {
                if ( paramError.message ) {
                    return paramError.message
                } else if ( paramError.keyword ) {
                    return paramError.keyword + ': ' + Object.keys(paramError.params).map(param=> '[' + param + ':' + paramError.params[param] + ']').join(', ')
                } else {
                    'RXDB VD2 Error'
                }
            })
            rtnMsg = msgs.join(",\n")
        }
        else if (error instanceof Error) {
            rtnMsg = `${error.message}`            
        } else if (error.error) {
            if (error.error instanceof ErrorEvent) {
                rtnMsg = `${error.error.message}`
            } else {
                const httpResp = error
                const respBodyObj = httpResp.error
                if (respBodyObj.error?.reason) {
                    // json content from server that has 'error' element
                    rtnMsg = respBodyObj.error.reason
                    //console.log(JSON.stringify(rtnMsg))
                } else if (respBodyObj instanceof ProgressEvent && respBodyObj.type == 'error') {
                    // client side error
                    rtnMsg = 'Network error occurred'
                } else {
                    rtnMsg = httpResp.statusText ? `${httpResp.statusText} (${error.url})` : "Unknown Error"
                }
            }
        } else if (error instanceof Event && error.type ) {
            rtnMsg = `Error event '${error.type}' (target: ${error.target})`
        } else {
            //console.error(error)
            rtnMsg = `${error}`
        }
        //console.error(error);
        if ( rtnMsg?.length > 200 ) {
            rtnMsg = rtnMsg.slice(0,200) + '...'
        }
        return rtnMsg
    }


}

export type GraphQLExtensionsEx = {
    code: string|number
    constraint: string
    detail: string
    file: string
    length: number
    line: string|number
    message: string
    name: string // ex "QueryFailedError"
    parameters: Array<any>
    query: string
    routine: string
    schema: string //"testbed"
    severity: string //"ERROR"
    stacktrace: Array<string>
    table: string //"testseq"
}

export class TestbedRxdbGraphQlSyncError {

    innerError : GraphQLError
    
    constructor( public error: any ) {
        this.innerError = error?.innerErrors && error.innerErrors[0]
    }

    get pathArray() {
        return this.innerError?.path as Array<string|number>
    }

    get extensions(){
        return this.innerError?.extensions
    }

    get extensionsEx() : GraphQLExtensionsEx {
        return this.extensions?.exception as GraphQLExtensionsEx
    }    

    get extensionsExParams() {
        return this.extensionsEx?.parameters
    }    

    // override this for each collection if needed
    extractDocId() {
        // if it was a db error then usually the docId is first value in parameters
        const dbParms = this.extensionsExParams
        return dbParms && dbParms[0]
    }

    extractReason() {
        const ex = this.extensionsEx
        let reason: string;
        if ( ex ) {
            reason = ex.detail || ex.message;
            if ( !reason ) {
                console.error('Cannot find rxdb graphql extensions error reason',ex);
                reason = ex.name || `GraphQL sync ext error: ${ex}`;
            }
        }
        if ( !reason ) {
            reason = this.error?.message || `GraphQL sync error: ${this.error}`;
        }
        return reason;
    }

    equals( e : TestbedRxdbGraphQlSyncError ) {
        const lhsPathArray = this.pathArray
        const rhsPathArray = e?.pathArray
        if ( !lhsPathArray ) {
            if ( !rhsPathArray ) {
                // neither error has path. check extensions exceptions next
            } else {
                return false
            }
        } else if ( !lhsPathArray.equals(rhsPathArray) ) {
            return false
        }
        const extEx = this.extensionsEx
        const otherExtEx = e?.extensionsEx
        if ( extEx == otherExtEx ) {
            return true
        } else if ( !extEx ) {
            return false
        } 
        return extEx.length == otherExtEx?.length &&
            this.extensionsExParams?.equals(e?.extensionsExParams)
    }
}